import React from 'react'
import classnames from 'classnames'

export type VoiceMode = 'ai-voices' | 'voice-cloning'

interface VoiceModeSelectionRowProps {
  readonly selectedMode: VoiceMode
  readonly voiceCloningAvailable: boolean
  onSelect(mode: VoiceMode): void
  onUpgrade(): void
}

const VoiceModeSelectionRow: React.FC<VoiceModeSelectionRowProps> = ({
  selectedMode,
  voiceCloningAvailable,
  onSelect,
  onUpgrade,
}) => {
  const handleSelectAiVoices = () => onSelect('ai-voices')
  const handleSelectVoiceCloning = () => {
    if (voiceCloningAvailable) {
      onSelect('voice-cloning')
    } else {
      onUpgrade()
    }
  }

  return (
    <div className="QuickStart__voice-mode-section">
      <h3 className="QuickStart__voice-mode-heading">Choose a voice mode</h3>
      <div className="QuickStart__voice-mode-row">
        <button
          type="button"
          data-testid="quickstart-select-ai-voices"
          className={classnames('QuickStart__voice-mode-card', {
            'QuickStart__voice-mode-card-selected': selectedMode === 'ai-voices',
          })}
          onClick={handleSelectAiVoices}
        >
          <span className="QuickStart__voice-mode-title">AI voices</span>
          <span className="QuickStart__voice-mode-description">Detects speakers and matches voices by gender</span>
          <span className="QuickStart__voice-mode-badge">Included</span>
        </button>
        <button
          type="button"
          data-testid="quickstart-select-voice-cloning"
          className={classnames('QuickStart__voice-mode-card', {
            'QuickStart__voice-mode-card-selected': selectedMode === 'voice-cloning',
            'QuickStart__voice-mode-card-locked': !voiceCloningAvailable,
          })}
          onClick={handleSelectVoiceCloning}
        >
          <span className="QuickStart__voice-mode-title">Clone original voices</span>
          <span className="QuickStart__voice-mode-description">Preserves each speaker&apos;s original voice</span>
          {!voiceCloningAvailable && <span className="QuickStart__voice-mode-badge">Upgrade</span>}
        </button>
      </div>
    </div>
  )
}

export default VoiceModeSelectionRow
